import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../createApiConfig';

export const sMServicesCategoriesApi = createApi({
  reducerPath: 'sMServicesCategoriesApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['ServiceCategories'],
  endpoints: builder => ({
    getServiceCategories: builder.query({
      query: (params) => ({
        url: `/services/categories/`,
        params,
      }),
      providesTags: ['ServiceCategories'],
    }),
    getServiceCategoriesById: builder.query({
      query: id => `/services/categories/${id}/`,
      providesTags: ['ServiceCategories'],
    }),
    createServiceCategories: builder.mutation({
      query: body => ({
        url: '/services/categories/',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['ServiceCategories'],
    }),
    updateServiceCategories: builder.mutation({
      query: ({ id, body }) => ({
        url: `/services/categories/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['ServiceCategories'],
    }),
    patchServiceCategories: builder.mutation({
      query: ({ id, body }) => ({
        url: `/services/categories/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['ServiceCategories'],
    }),
  }),
});

export const {
  useGetServiceCategoriesQuery,
  useLazyGetServiceCategoriesQuery,
  useGetServiceCategoriesByIdQuery,
  useCreateServiceCategoriesMutation,
  useUpdateServiceCategoriesMutation,
  usePatchServiceCategoriesMutation,
} = sMServicesCategoriesApi;